module.exports = __webpack_public_path__ + "img/rejected.92a32d7c.png";